<template>
  <div class="main">
    <div class="container">
      <ul class="breadcrumb">
        <li>
          您所在的位置：
        </li>
        <li class="alpha hover">
          <a>首页</a>
        </li>
        <li class="alpha hover" @click="$router.push('/')">
          <a>行政处罚信息公开</a>
        </li>
        <li class="active">
          行政处罚案件信息
        </li>
      </ul>
      <div class="box box-default">
        <div class="case-detail">
          <h3>
            行政处罚案件信息
          </h3>
          <table class="table table-bordered table-custom table-detail">
            <tbody>
              <tr>
                <th style="width: 20%" class="cyan">
                  案件名称
                </th>
                <td colspan="3">
                  {{ info.casename }}
                </td>
              </tr>

              <!--
自然人
-->

              <tr v-show="info.partytype == 1">
                <th class="cyan">
                  处罚决定书编号
                </th>
                <td>
                  {{ info.penaltydecisionno }}
                </td>
                <td style="width: 20%" class="cyan">
                  自然人姓名
                </td>
                <td style="width: 30%">
                  {{ info.party }}
                </td>
              </tr>
              <tr v-show="info.partytype == 3">
                <th class="cyan">
                  处罚决定书编号
                </th>
                <td colspan="3">
                  {{ info.penaltydecisionno }}
                </td>
              </tr>
              <tr v-show="info.partytype == 3">
                <th class="cyan">
                  企业或组织名称
                </th>
                <td></td>
                <td style="width: 20%" class="cyan">
                  法定代表人姓名
                </td>
                <td style="width: 30%">
                  {{ info.partylegalrepresentative }}
                </td>
              </tr>
              <tr v-if="info.partytype == 2">
                <th class="cyan">
                  处罚决定书编号
                </th>
                <td colspan="3">
                  {{ info.penaltydecisionno }}
                </td>
              </tr>
              <tr v-if="info.partytype == 2">
                <th style="width: 20%" class="cyan">
                  {{
                    info.partytype == 1
                      ? '自然人姓名'
                      : info.partytype == 2
                      ? '企业或组织名称'
                      : info.partytype == 3
                      ? '个体工商户'
                      : ''
                  }}
                </th>
                <td :colspan="info.partytype == 2 ? '0' : '3'">
                  {{ info.party }}
                </td>
                <td style="width: 20%" v-if="info.partytype == 2" class="cyan">
                  法定代表人姓名
                </td>
                <td v-if="info.partytype == 2" style="width: 30%">
                  {{ info.partylegalrepresentative }}
                </td>
              </tr>
              <!-- partytype == 3 -->

              <tr>
                <th class="cyan">
                  处罚事由
                </th>
                <td colspan="3">
                  {{ info.casecausename }}
                </td>
              </tr>
              <tr>
                <th class="cyan">
                  处罚依据
                </th>
                <td colspan="3">
                  {{ info.accordingtoclause }}
                </td>
              </tr>
              <tr>
                <th class="cyan">
                  处罚结果
                </th>
                <td colspan="3">
                  {{ info.penaltydecision }}
                </td>
              </tr>
              <tr>
                <th class="cyan">
                  执法单位名称
                </th>
                <td colspan="3">
                  {{ info.penaltyorganname }}
                </td>
              </tr>
              <tr>
                <th class="cyan">
                  处罚决定日期
                </th>
                <td colspan="3">
                  {{ info.penaltydate ? info.penaltydate.split(' ')[0] : '' }}
                </td>
              </tr>
              <tr>
                <th class="cyan" colspan="4" style="text-align:center">
                  其他信息
                </th>
              </tr>
              <tr>
                <td colspan="4" style="text-align:center">
                  无
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCaseInfoDetail } from '@/http'

export default {
  data() {
    return {
      info: {},
    }
  },
  methods: {},
  created() {
    getCaseInfoDetail(this.$route.query.guid).then((res) => {
      this.info = res
    })
  },
}
</script>
<style lang="less">
#app,
pageFooter {
  //background-color: #EBE9EA;
}

.main {
  .container {
    width: 1000px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;

    .breadcrumb {
      background-color: transparent;
      font-size: 14px;
      margin-bottom: 10px;
      padding: 0 8px 10px 0;
      list-style-type: none;

      li + li:before {
        content: '>';
        color: #333;
        padding: 0 5px;
      }

      :nth-child(2):before {
        display: none;
      }

      .hover {
        cursor: pointer;
      }

      li {
        display: inline-block;
      }

      .alpha {
        a {
          color: #333;
        }
      }

      .active {
        color: #777;
      }
    }

    .table-bordered {
      border: 1px solid #ddd;
    }

    .case-detail {
      padding: 30px 50px;
      background-color: #fff;
      color: #333;

      h3 {
        margin: 0 0 20px 0;
        font-size: 18px;
        font-weight: 400;
      }
    }

    .table {
      width: 100%;
      max-width: 100%;
      margin-bottom: 20px;
      background-color: transparent;
      border-spacing: 0;
      border-collapse: collapse;
    }

    .table-custom th,
    .table-custom td {
      padding: 15px 8px !important;
      border-color: #54a7c8 !important;
    }

    .table-custom .cyan {
      background-color: #d8f5fb;
      text-align: right;
      font-weight: normal;
      font-size: 15px;
      border: 1px solid #ddd;
    }

    .table-custom td {
      padding: 15px 8px !important;
      border-color: #54a7c8 !important;
      font-size: 14px;
      border: 1px solid #ddd;
      line-height: 1.42857143;
      vertical-align: top;
    }
  }
}
</style>
